import styled from 'styled-components/macro';
import Scrollbar from '~/components/Scrollbar';
import images from '~/constants/images';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-width: 100%;
`;

export const Container = styled.div`
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  padding: ${({ hasNavBar }) => (hasNavBar ? `0 0 60px 0` : `0`)};
  background-color: ${({ theme }) => theme.light};
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    background-color: ${({ theme, mobileBackground }) =>
      mobileBackground || theme.light};
  }
`;

export const BGbit = styled.div`
  position: absolute;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.white};

  &:before {
    content: ' ';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.3;
    background-image: url(${images.beat});
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Content = styled(Scrollbar)`
  width: 100%;
  height: 100%;
  flex-grow: 1;
`;

export const BottomModal = styled.div`
  position: sticky;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  position: relative;
`;

export const SubHeaderContainer = styled.div``;

export const Footer = styled.div`
  width: 100%;
  position: relative;
`;
